import LazyLoad from "vanilla-lazyload";

document.addEventListener('DOMContentLoaded',function() {

   window.myLazyLoad = new LazyLoad();
    
}, false);
